import createGetters from '@/store/model/getters'
import state from './state'

const getters = createGetters(state)

export default getters